import moment from 'moment';

const DEALER_WEEKS = [4, 8];

export const calcDays = (initDate, endDate) => {
  if (!initDate || !endDate) {
    return null;
  }
  return moment(endDate).diff(moment(initDate), 'days');
};

const validateChanges = (row, originalRow) => {
  const {comment, status} = row;
  const {'comment': originalComment, 'status': originalStatus} = originalRow;
  
  if (comment !== originalComment || status !== originalStatus) {
    return true;
  }

  return false;
};

export const validateWeekItems = (row, originalRow) => {
  if (DEALER_WEEKS.includes(row.idWeek) && validateChanges(row, originalRow)) {
    return true;
  }
  return false;
};

